
export default {
  'isochronesDetails': {
    'polygons': 'Polygones',
    'center': 'Centre',
    'reachCenters': 'Centres de atteindre',
    'toggleVisibility': 'Basculer la visibilité',
    'opacity': 'Opacité'
  }
}
